import { Component, OnInit } from '@angular/core';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { UtilService } from 'src/app/shared/services/util.service';
import * as moment from 'moment';

@Component({
    selector: 'app-agendamiento-turno-virtual-uac',
    templateUrl: './agendamiento-turno-virtual-UAC.component.html',
    styleUrls: ['./agendamiento-turno-virtual-UAC.component.scss']
})

export class AgendamientoTurnoVirtualUACComponent implements OnInit {

    public filtroTramite: string;
    public filtroSede: string;
    public filtroPrioridad: string = null;
    public filtroMotivoPrioridad: string;
    public filtroTipoDiscapacidad: string;
    public filtroDocumento: string;
    public filtroFechaInicio: Date;
    public filtroFechaFin: Date;
    public placeholderDate: string;

    public sede: string[];
    public tramites: string;
    public tipoDiscapacidad: string;
    public motivoDePrioridad: string;
    public datosArchivo: any;
    public validar = true;
    public habilitarMotivosPrioridad = true;
    public valor = false;

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService,
    ) {
        this.sede = [];
    }
    ngOnInit() {
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.filtroSede = sessionStorage.getItem(ConstantesService.SEDE_DEFECTO_SESSSION);
        this.obtenerTramite();
        this.obtenerSede();
        this.obtenerMotivosPrioridad();
        this.obtenerTiposDiscapacidad();
    }

    /**
     * Consulta los Trámites Existente
     */
    public obtenerTramite() {
        this.spinner.show();
        const serviceProvider = 'tramiteUAC';
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=estado', ConstantesService.ESTADO_TRAMITE_ACTIVO]);
        let url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
        url = url + '&orderBy=nombre$ASC';
        this.global.getGenerico(url).subscribe(
            data => {
                this.tramites = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Cargar los servicios');
            }
        );
    }

    /**
     * Consulta los tipo de Sedes Existente
     */
    public obtenerSede() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.sede = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener las Sedes');
            }
        );
    }

    /**
     * Consulta los motivos de prioridad Existente
     */
    public obtenerMotivosPrioridad() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'MotivoPrioridad']);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.motivoDePrioridad = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener los Motivos de Prioridad');
            }
        );
    }

    /**
     * Consulta los tipos de discapacidad Existente
     */
    public obtenerTiposDiscapacidad() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'TipoDiscapacidad']);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.tipoDiscapacidad = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener los Tipos de Discapacidad');
            }
        );
    }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    public GenerarReporteTurnoVirtualUAC() {
        if (this.filtroFechaInicio < this.filtroFechaFin || this.filtroFechaInicio.getTime() === this.filtroFechaFin.getTime()) {
            this.GenerandoResporte();

            // if (this.filtroFechaFin < new Date()) {
            // } else {
            //     this.alertService.generateAlertError('La fecha fin no puede ser superior a la fecha de sistema', '');
            // }
        } else {
            this.alertService.generateAlertError('La fecha fin no puede ser inferior a la fecha inicio', '');
        }
    }
    public GenerandoResporte() {
        this.spinner.show();
        const filtros = {
            filtroTramite: this.filtroTramite,
            filtroSede: this.filtroSede,
            filtroPrioridad: this.filtroPrioridad,
            filtroMotivoPrioridad: this.filtroMotivoPrioridad,
            filtroTipoDiscapacidad: this.filtroTipoDiscapacidad,
            filtroDocumento: this.filtroDocumento,
            filtroFechaInicio: this.filtroFechaInicio,
            filtroFechaFin: this.filtroFechaFin
        };
        const serviceProvider = 'reporteTurnoVirtualUAC';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.global.postGenerico(url, filtros).subscribe(
            data => {
                this.datosArchivo = data;
                this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                this.descargarArchivo();
            }, err => {
                if (err.status === 500) {
                    this.cathException(err.error.message);
                } else {
                    this.cathException('El reporte no se ha podido generar');
                }
            }
        );
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Metodo que valida los campos obligatorios para porder habilitar el boton Generar Reporte
     */
    public validacion(valor) {
        if (this.utilService.validarCamposObligatorios(this.filtroPrioridad) &&
            this.utilService.validarCamposObligatorios(this.filtroFechaInicio) &&
            this.utilService.validarCamposObligatorios(this.filtroFechaFin)) {
            this.validar = false;
        } else {
            this.validar = true;
        }

        if (!this.utilService.validarCamposObligatorios(this.filtroPrioridad) ||
            this.filtroPrioridad === '0') {
            this.habilitarMotivosPrioridad = true;
            this.filtroMotivoPrioridad = undefined;
        } else {
            this.habilitarMotivosPrioridad = false;
        }
        if (!this.utilService.validarCamposObligatorios(this.filtroTipoDiscapacidad)) {
            this.filtroTipoDiscapacidad = undefined;
        }
        if (!this.utilService.validarCamposObligatorios(this.filtroMotivoPrioridad)) {
            this.filtroMotivoPrioridad = undefined;
        }
    }

    /**
     * Método que valida la fecha Inicial y la anexa a una variable especifica filtroFechaInicio
     * @param event resive la fecha seleccionada por el usuario
     */
    public handlerDatePickeRInicio(event) {
        this.filtroFechaInicio = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
    }

    /**
     * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
     * @param event resive la fecha seleccionada por el usuario
     */
    public handlerDatePickeRFin(event) {
        this.filtroFechaFin = moment(this.utilService.convertirFechaConcatenada(event), 'DD-MM-YYYY').toDate();
    }

    /**
     * Método que consulta la sede por defecto
     */
    public consultarParametroPorDefecto() {
        this.spinner.show();
        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.postGenerico(url, [DominiosService.SEDE_POR_DEFECTO]).subscribe(
            data => {
                if (data.length > 0) {
                    this.filtroSede = data[0].valor;
                    this.obtenerSede();
                } else {
                    this.alertService.generateAlertError('Ocurrio un error consultando el parametro por defecto de la sede', 'Error');
                    this.spinner.hide();
                }
            }, err => {
                this.alertService.generateAlertError('Ocurrio un error consultando el parametro por defecto de la sede', 'Error');
                this.spinner.hide();
            }
        );
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
